import { TRUSTEDSHOP_IDS } from './constants';
import type { TrustBadgeType } from '../types';

export function getTrustedShopId(siteBranchId: number) {
  return TRUSTEDSHOP_IDS[siteBranchId];
}

function updateTrustedShopBadgeDisplayValue(hide: boolean) {
  const trustedShopBadge: TrustBadgeType = document.querySelector('[id^="trustbadge-container-"]');

  if (trustedShopBadge?.style) {
    trustedShopBadge.style.display = hide ? 'none' : 'block';
  }
}

export function hideTrustedShopBadge(hide: boolean) {
  return updateTrustedShopBadgeDisplayValue(hide);
}

// Copied from gatsby, it is commented out because it is not used in the current codebase. It is for a future use
/*
  export const updateTrustBadgeZIndex = (zIndex: number) => {
    const trustedShopBadge: TrustBadgeType = document.querySelector('[id^="trustbadge-container-"]');
    const trustPilotBadge: TrustBadgeType = document.querySelector('[id^="tp_wrapper"]');

    if (trustedShopBadge?.style) {
      trustedShopBadge.style.zIndex = `${zIndex}`;
    }

    if (trustPilotBadge?.style) {
      trustPilotBadge.style.zIndex = `${zIndex}`;
    }
  };
*/
